import { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { DeepLinkProvider } from "@/hooks/tauri/DeepLinkProvider";
import AuthenticationProvider from "@/infra/AuthenticationProvider";
import { LoadingOverlay } from "@akina/presentation";
import App from "./App";

export function Providers() {
  return (
    <BrowserRouter>
      <DeepLinkProvider>
        <AuthenticationProvider>
          <Suspense fallback={<LoadingOverlay />}>
            <App />
          </Suspense>
        </AuthenticationProvider>
      </DeepLinkProvider>
    </BrowserRouter>
  );
}
